import React, { useState, useEffect } from 'react';
import { I18n } from 'react-redux-i18n';
import FiltersVat from '../components/Filters/FiltersVat';
import ReactTable from 'react-table';
import EditableCell from './EditableCell';
import CellEditable from './CellEditable';
import { connect } from 'react-redux';
import { vatExportLabels } from '../constant';
import CallApi from '../../../utils/CallApi';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { makeStyles } from '@material-ui/core';

import { addFlashMessage } from '../../../common/flashMessage/actions/flashMessages';
import CloseModal from '../../CustomerAccount/svg/CloseModal';
import AdminAccounts from './AdminAccounts';
import GlobalSettings from '../components/GlobalSettings';
import AccountsHandler from '../components/AccountsHandler';
import AccountsTable from '../components/AccountTable';
import ModalEditAccount from './ModalEditAccount';
import SwitchProductMode from '../components/SwitchProductMode';

const useStyles = makeStyles(theme => ({
	root: {
		margin: theme.spacing(0.1),
		backgroundColor: '#e7e7e8',
		fontFamily: 'FuturaBook',
		border: 'none',
	},
	togglBtn: {
		margin: '2px 2px 2px 2px!important',
		textTransform: 'none',
		fontFamily: 'FuturaBook',
		color: 'none',
		fontSize: '13px',
		border: 'none',
		width: '110px',
		height: '30px',
		'&$selected': {
			borderRadius: '3px',
			color: '#262967',
			backgroundColor: 'white',
			margin: '2px 4px 2px 4px',
			'&:hover': {
				backgroundColor: 'white',
			},
		},
		'&:hover': {
			backgroundColor: 'transparent',
		},
		'&:first-child ': {
			width: '135px',
		},
		'&:last-child ': {
			width: '170px',
		},
	},
	selected: { borderRadius: '3px', height: '30px', width: '110px' },
}));

const paramsLabel = {
	society: 'Société',
	etab: 'Etab',
	journal: 'Journal',
	pieceType: 'Type de pièce',
	type: 'Type',
	tiers: 'Tiers',
	//axeAnal: 'Axe analytique',
	sectionAnal: 'Section analytique',
	devise: 'Devise',
	lib: 'Libellé',
	//paymentMod: 'Mode de paiement',
	//reglMode: 'Mode Rég.',
	//profilVat: 'Profil TVA',
	//intraco: 'Intraco',
	//nature: 'Nature',
	//sectionAxe1: 'Axe 1',
	//sectionAxe2: 'Axe 2',
	//sectionAxe3: 'Axe 3',
};

const getEdidtableCells = (r, accSelected, onChangeFct) => {
	const accInfos = r.original;
	const isDefault = r.column.id === 'Default' ? true : false;
	const isLabel = r.column.id === 'label';
	const cellVal = isLabel
		? r.original.label
		: r.column.id !== r.original.indicator
			? ''
			: r.original.account_number;
	const valueToUpdate = isLabel ? 'label' : 'account_number';
	return (
		<CellEditable
			val={cellVal}
			onBlurFct={(val, isLabel) => {
				accInfos[valueToUpdate] = isLabel ? val : parseInt(val);
				onChangeFct(accInfos, isLabel);
			}}
			isLabel={isLabel}
		/>
	);
};

export const ACCOUNT_TYPES = [
	'product',
	'payment',
	'vat',
	'customer',
	'achats',
	'ventes',
	'offered',
	'discount',
	'_offered',
	'_discount',
];

// Signature stable des liaisons compte <-> élément, pour savoir si l'état courant diffère de
// l'état enregistré. On ignore `id` (une case recochée repart avec id: '' alors que la liaison
// enregistrée porte son id de base) et on normalise all_tax_rates (1/0 côté serveur, booléen ou
// null côté création) ainsi que l'ordre des clés et des taux.
const linkingSignature = linking => {
	if (!linking) return '';
	const parts = [];
	Object.keys(linking).forEach(accountId => {
		Object.keys(linking[accountId] || {}).forEach(idTable => {
			const link = linking[accountId][idTable] || {};
			const taxRates = (link.tax_rates || []).map(String).sort().join(',');
			parts.push(
				`${accountId}|${idTable}|${link.type || ''}|${
					link.all_tax_rates ? 1 : 0
				}|${taxRates}`
			);
		});
	});
	return parts.sort().join(';');
};

function NewVatSettings({
	onCloseDrawer,
	addFlashMessage,
	isSwift,
	isMaster,
	configTarget,
}) {
	const accountTypes = ACCOUNT_TYPES.map(t => ({
		label: I18n.t('exportVat.account_type.' + t),
		type: t,
	}));

	const [accountVatList, setAccountVatList] = useState(null);
	const [initFilterValue, setInitFilterValue] = useState(
		JSON.parse(JSON.stringify(accountTypes[0]))
	);
	const [allLoaded, setAllLoaded] = useState(false);
	const [valChanged, setValChanged] = useState(false);
	// Signature des liaisons telles qu'enregistrées, et état "modifié" du bouton Enregistrer.
	// Distinct de valChanged, qui sert aussi à déclencher le rafraîchissement de l'aperçu à la
	// fermeture du tiroir et ne doit donc pas retomber à false.
	const [savedLinkingSignature, setSavedLinkingSignature] = useState('');
	const [linkingDirty, setLinkingDirty] = useState(false);
	const [toggleSelected, setToggleSelected] = useState('accounts');
	// Type de compte à présélectionner dans l'onglet "Créer compte", posé par le bouton "Nouveau"
	// de l'onglet Comptes.
	const [createAccType, setCreateAccType] = useState(null);

	// Ouverture ciblée depuis la modale des erreurs. Deux cas :
	//  - { settingKey }  -> onglet Configuration, sur le champ concerné
	//  - { accountType } -> onglet Comptes, filtré sur ce type de compte
	useEffect(() => {
		if (!configTarget) return;
		if (configTarget.settingKey) {
			setToggleSelected('configuration');
		} else if (configTarget.accountType) {
			setToggleSelected('accounts');
			setInitFilterValue({
				label: I18n.t('exportVat.account_type.' + configTarget.accountType),
				type: configTarget.accountType,
			});
		}
	}, [configTarget]);
	const [floors, setFloors] = useState(null);
	const [vats, setVats] = useState(null);
	const [productTypes, setProductTypes] = useState(null);
	const [paymentTypes, setPaymentTypes] = useState(null);
	const [discounts, setDiscounts] = useState(null);
	const [products, setProducts] = useState(null);
	const [accountLinking, setAccountLinking] = useState(null);
	const [contacts, setContacts] = useState(null);
	const [cashbackPaymentTypes, setCashbackPaymentTypes] = useState(null);
	const [accountInEdit, setAccountInEdit] = useState(null);
	const [tags, setTags] = useState(null);

	const classes = useStyles();

	useEffect(() => {
		getVatListAccounts();
		getAllAccountLinking();
		getAllFloors();
		getAllVat();
		getAllProductTypes();
		getAllPaymentTypes();
		getAllDiscounts();
		getAllProducts();
		getContacts();
		getTags();
		if (isSwift) getCashBackPaymentTypes();
	}, []);

	useEffect(() => {
		if (
			accountVatList &&
			floors &&
			vats &&
			productTypes &&
			paymentTypes &&
			discounts &&
			accountLinking &&
			products
		)
			setAllLoaded(true);
	}, [
		paymentTypes,
		vats,
		productTypes,
		accountVatList,
		initFilterValue,
		products,
		discounts,
	]);

	const fetcher = async (route, setter) => {
		try {
			const res = await CallApi('GET', route, '', '');

			if (res && res[0] && res[0].datas && setter) {
				return setter(res[0].datas);
			}
		} catch (error) {
			addFlashMessage({
				type: 'danger',
				text: 'Une erreur est survenue',
				persistent: false,
			});
		}
	};

	const getAllFloors = async () => {
		await fetcher('user/floorsName', setFloors);
	};
	const getAllVat = async () => {
		await fetcher('user/vat', setVats);
	};
	const getAllProductTypes = async () => {
		await fetcher('user/productTypes', setProductTypes);
	};
	const getAllPaymentTypes = async () => {
		await fetcher('user/paymentTypes', setPaymentTypes);
	};
	const getAllDiscounts = async () => {
		await fetcher('user/discounts', setDiscounts);
	};
	const getAllProducts = async () => {
		await fetcher('user/products', setProducts);
	};
	const getAllAccountLinking = async () => {
		await fetcher('exportVat/getAccountLinking', linking => {
			setAccountLinking(linking);
			setSavedLinkingSignature(linkingSignature(linking));
			setLinkingDirty(false);
		});
	};
	const getVatListAccounts = async () => {
		await fetcher('exportVat/getVatAccounts', setAccountVatList);
	};
	const getContacts = async () => {
		await fetcher('exportVat/getContacts', setContacts);
	};
	const getCashBackPaymentTypes = async () => {
		await fetcher('user/cashBackPaymentType', setCashbackPaymentTypes);
	};
	const getTags = async () => {
		await fetcher('exportVat/getTags', setTags);
	};

	if (cashbackPaymentTypes && cashbackPaymentTypes.length)
		accountTypes.push({
			label: I18n.t('exportVat.account_type.cashback'),
			type: 'cashback',
		});

	const updateSettings = async () => {
		// format object in array
		const _accountLinking = [];
		for (let account_id in accountLinking) {
			for (let id_table in accountLinking[account_id]) {
				if (accountLinking[account_id][id_table].tax_rates.length) {
					_accountLinking.push(
						...accountLinking[account_id][id_table].tax_rates.map(tr => ({
							...accountLinking[account_id][id_table],
							tax_rate: tr,
						}))
					);
				} else {
					_accountLinking.push({
						...accountLinking[account_id][id_table],
						tax_rate: null,
					});
				}
			}
		}

		try {
			await CallApi('POST', 'exportVat/updateVatLinking', '', {
				accountLinking: _accountLinking,
			})
				.then(results => {
					if (results && results.length) {
						addFlashMessage({
							type: 'success',
							text: 'Vos comptes comptables ont été mis à jour',
							persistent: false,
						});
						setAccountLinking(results[0].result);
						setSavedLinkingSignature(linkingSignature(results[0].result));
						setLinkingDirty(false);
						setValChanged(false);
					}
				})
				.catch(err => {
					console.error(err);
					addFlashMessage({
						type: 'danger',
						text: 'Une erreur est survenue',
						persistent: false,
					});
					return err;
				});
		} catch (err) {
			console.log('err');
		}
	};

	const deleteLinkByType = async type => {
		try {
			await CallApi('POST', 'exportVat/deleteVatLinkByType', '', {
				type,
			})
				.then(results => {
					// if (results && results.length) {
					// 	addFlashMessage({
					// 		type: 'success',
					// 		text: 'Vos liaisons produits ont bien été réinitialisées',
					// 		persistent: false,
					// 	});
					// }
				})
				.catch(err => {
					console.error(err);
					addFlashMessage({
						type: 'danger',
						text: 'Une erreur est survenue',
						persistent: false,
					});
					return err;
				});
			await getAllAccountLinking();
		} catch (err) {
			console.log(err);
		}
	};

	const updateVatKeys = async vatKeys => {
		try {
			const changes = Object.keys(vatKeys).reduce((acc, key) => {
				if (vatKeys[key] != accountVatList['vatKeys'][key])
					acc[key] = vatKeys[key];
				return acc;
			}, {});

			if (Object.values(changes).length) setValChanged(true);

			if (changes.hasOwnProperty('account_vat_ecriturenum')) {
				await CallApi('PATCH', 'exportVat/ecritureNum', '', {
					value: changes['account_vat_ecriturenum'],
				})
					.then(results => {
						//
					})
					.catch(err => {
						console.error(err);
						return err;
					});
			}

			await CallApi('POST', 'exportVat/updateVatKeys', '', {
				vatKeys: changes,
			})
				.then(results => {
					if (results && results.length) {
						addFlashMessage({
							type: 'success',
							text: 'Vos paramètres ont été mis à jour',
							persistent: false,
						});
						setAccountVatList({
							...accountVatList,
							vatKeys: results[0].result,
						});
					}
				})
				.catch(err => {
					console.error(err);
					addFlashMessage({
						type: 'danger',
						text: 'Une erreur est survenue',
						persistent: false,
					});
					return err;
				});
		} catch (err) {
			console.log(err);
		}
	};

	const onCellDataChanged = (
		accountId, // corresponds a _id
		tableId,
		type,
		create = true,
		linkVats = [] // pour les product types
	) => {
		let _accountLinking = JSON.parse(JSON.stringify(accountLinking));
		let tableIds = Array.isArray(tableId) ? tableId : [tableId];

		if (!_accountLinking[accountId]) _accountLinking[accountId] = {};

		for (let _tableId of tableIds) {
			if (type == 'product') {
				delete _accountLinking[accountId][_tableId];

				const all_tax_rates = create || vats.length == linkVats.length;
				if (create || linkVats.length)
					_accountLinking[accountId][_tableId] = {
						id: '',
						id_account: accountId,
						id_table: _tableId,
						type,
						tax_rates: create || all_tax_rates ? [] : [...linkVats],
						all_tax_rates,
					};
			} else {
				if (create) {
					_accountLinking[accountId][_tableId] = {
						id: '',
						id_account: accountId,
						id_table: _tableId,
						type,
						tax_rates: [],
						all_tax_rates: null,
					};
				} else {
					delete _accountLinking[accountId][_tableId];
				}
			}
		}

		setAccountLinking(_accountLinking);
		// valChanged reste vrai : il pilote le rafraîchissement de l'aperçu à la fermeture.
		setValChanged(true);
		// Le bouton Enregistrer, lui, ne s'active que si l'état diffère réellement de l'enregistré :
		// revenir à la configuration d'origine le regrise.
		setLinkingDirty(linkingSignature(_accountLinking) !== savedLinkingSignature);
	};

	const handleDeleteAcc = async id => {
		try {
			const res = await CallApi('POST', 'exportVat/deleteVatAccounts', '', {
				id,
			})
				.then(results => {
					refreshAccounts();
					addFlashMessage({
						type: 'success',
						text: 'Votre compte comptable a bien été supprimé',
						persistent: false,
					});
				})
				.catch(err => {
					console.log(err);
					addFlashMessage({
						type: 'danger',
						text: 'Une erreur est survenue',
						persistent: false,
					});
				});
		} catch (error) {
			console.log(error);
		}
	};

	const deleteAccount = async id => {
		if (
			window.confirm('Êtes-vous sûr de voiloir supprimer ce compte comptable ?')
		) {
			await handleDeleteAcc(id);
		}
	};

	const editAccount = async id => {
		const acc = null;
		for (let type in accountVatList) {
			let acc = accountVatList[type].find(a => a._id == id);
			if (acc) {
				if (
					['customer', 'achats', 'ventes'].includes(acc.type) &&
					accountLinking[acc._id]
				) {
					acc.table_id = Object.keys(accountLinking[acc._id])[0];
				}
				setAccountInEdit(acc);
				break;
			}
		}
	};
	const onEditAccount = async data => {
		//data == null -> cancel
		setAccountInEdit(null);
		if (data) {
			try {
				await CallApi('POST', 'exportVat/updateVatAccounts', '', {
					...data,
					all_floors: data.floors.length === 0,
				})
					.then(results => {
						refreshAccounts();
						addFlashMessage({
							type: 'success',
							text: 'Votre compte comptable a bien été mis à jour',
							persistent: false,
						});
					})
					.catch(err => {
						console.log(err);
						addFlashMessage({
							type: 'danger',
							text: 'Une erreur est survenue',
							persistent: false,
						});
					});
			} catch (error) {
				console.log(error);
			}
		}
	};

	const handleCloseDrawer = e => {
		onCloseDrawer(valChanged);
		setValChanged(false);
	};

	const handleToggleMenu = (e, newAlignement) => {
		if (newAlignement) setToggleSelected(newAlignement);
	};

	const refreshAccounts = async () => {
		await getVatListAccounts();
		await getAllAccountLinking();
	};

	const eventCreateAccount = async type => {
		await refreshAccounts();
		handleToggleMenu(null, 'accounts');
		const filter = accountTypes.find(at => at.type == type);
		setInitFilterValue(filter);
	};

	return (
		<div className="vat-settings-container">
			<div className="vat-settings-header">
				<div className="vat-settings-title">
					<h4>Configuration des comptes</h4>
					<div
						onClick={e => {
							handleCloseDrawer(e);
						}}>
						<CloseModal />
					</div>
				</div>
				<div className="vat-setting-toggle">
					<ToggleButtonGroup
						classes={{ root: classes.root }}
						value={toggleSelected}
						exclusive
						onChange={handleToggleMenu}
						aria-label="selected toggle">
						<ToggleButton
							classes={{ root: classes.togglBtn, selected: classes.selected }}
							value="accounts">
							<span>Comptes</span>
						</ToggleButton>
						<ToggleButton
							classes={{ root: classes.togglBtn, selected: classes.selected }}
							value="handler">
							<span>Créer compte</span>
						</ToggleButton>
						<ToggleButton
							classes={{ root: classes.togglBtn, selected: classes.selected }}
							value="configuration">
							<span>Configuration</span>
						</ToggleButton>
					</ToggleButtonGroup>
				</div>
			</div>

			<React.Fragment>
				{toggleSelected === 'accounts' ? (
					<div className="vat-settings-main">
						<div className="vat-settings-table-container">
							{allLoaded ? (
								<>
									<div className="vat-settings-switch">
										<div className="vat-settings-filter-container">
											<div
												className="vat-filter-list"
												style={{ marginBottom: 20, marginTop: 10 }}>
												<span className="export-filter-title">
													{I18n.t('exportReport.accounts')}
												</span>

												<div className="vat-accounts-filter-row">
													<FiltersVat
														multiple={false}
														monoSelect={true}
														label={initFilterValue.label}
														selected={[initFilterValue]}
														datas={JSON.parse(JSON.stringify(accountTypes))}
														paramsLabel="label"
														paramsValue="type"
														inputClassName="dataExport_filter_input"
														inputLabelClassName="dataExport_input_label"
														onClose={(data, pValue) => {
															if (!!data) {
																setInitFilterValue(data);
															}
															return;
														}}
													/>
													{/* Bascule vers "Créer compte" avec le type courant déjà
													    sélectionné, donc le bon formulaire ouvert. */}
													<button
														className="vat-btn-add-account"
														type="button"
														onClick={() => {
															setCreateAccType(initFilterValue.type);
															setToggleSelected('handler');
														}}>
														{I18n.t('exportVat.btn_new_account')}
													</button>
													{/* Valider remonté ici : dans .vat-settings-footer
													    (height: 20%) il était rejeté en bas du tiroir,
													    hors de vue. */}
													<div className="vat-settings-footer">
														<button
															className={`btn-vat-settings validation ${
																linkingDirty ? '' : ' disabled'
															}`}
															disabled={!linkingDirty}
															onClick={() => {
																updateSettings();
															}}>
															Enregistrer
														</button>
													</div>
												</div>
											</div>
											{initFilterValue.type === 'product' ? (
												<SwitchProductMode
													vatKeys={accountVatList['vatKeys']}
													onSave={updateVatKeys}
													deleteLinkByType={deleteLinkByType}
													disabled={!tags || (tags && !tags.length)}
													isMaster={isMaster}
												/>
											) : null}

											{/*	<button className="vat-btn-add-account">Ajouter compte</button>*/}
										</div>
									</div>
									<AccountsTable
										type={initFilterValue.type}
										accounts={accountVatList}
										floors={floors}
										vats={vats}
										productTypes={productTypes}
										tags={tags}
										paymentTypes={paymentTypes}
										discounts={discounts}
										cashbackPaymentTypes={cashbackPaymentTypes}
										links={accountLinking}
										products={products}
										onLinkChange={onCellDataChanged}
										onDelete={deleteAccount}
										onEdit={editAccount}
										contacts={contacts}
										productMode={
											accountVatList['vatKeys']['account_vat_product_mode']
										}
									/>
								</>
							) : (
								'Chargement des données...'
							)}
						</div>
					</div>
				) : toggleSelected === 'handler' ? (
					<AccountsHandler
						floors={floors}
						contacts={contacts}
						onCreate={eventCreateAccount}
						accounts={accountVatList}
						cashbackPaymentTypes={cashbackPaymentTypes}
						initialAccType={createAccType}
					/>
				) : (
					<div className="vat-account-admin">
						{accountVatList && accountVatList['vatKeys'] ? (
							<AdminAccounts
								vatKeys={accountVatList['vatKeys']}
								paymentTypes={paymentTypes}
								onSave={updateVatKeys}
								focusSetting={configTarget && configTarget.settingKey}
							/>
						) : (
							'Chargement des données...'
						)}
					</div>
				)}

				{accountInEdit ? (
					<ModalEditAccount
						account={accountInEdit}
						floors={floors}
						contacts={contacts}
						onClose={onEditAccount}
						accountList={accountVatList}
					/>
				) : (
					''
				)}
			</React.Fragment>
		</div>
	);
}

function mapStateToProps(state) {
	return { user: state.auth.user };
}

export default connect(mapStateToProps, { addFlashMessage })(NewVatSettings);
